/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warehouse': {
    width: 230,
    height: 188,
    viewBox: '0 0 230 188',
    data: '<path pid="0" d="M224.22 53.327L119.68 1.106a10.491 10.491 0 00-9.36 0L5.78 53.327A10.448 10.448 0 000 62.67v20.888A10.449 10.449 0 0010.45 94h10.46v83.554A10.448 10.448 0 0031.36 188h167.28a10.448 10.448 0 0010.45-10.444V94h10.46A10.449 10.449 0 00230 83.558V62.67a10.448 10.448 0 00-5.78-9.343zm-77.86 51.12H83.64V94h62.72v10.445zm-62.72 20.888h62.72v10.444H83.64v-10.444zm0 31.333h62.72v10.444H83.64v-10.444zm125.45-83.554h-10.45a10.453 10.453 0 00-10.46 10.444v83.554h-20.91V83.558a10.451 10.451 0 00-10.45-10.444H73.18a10.451 10.451 0 00-10.45 10.444v83.554H41.82V83.558a10.453 10.453 0 00-10.46-10.444H20.91v-3.978l94.09-47 94.09 47v3.978z" fill-rule="evenodd"/>'
  }
})
